import {PATH} from '../Router.config';

export const isHomeRoute = (path: string) => path === PATH.HOME;
